(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var toggles = document.querySelectorAll('[data-ia-toggle]');

    toggles.forEach(function (toggle) {
      if (toggle.disabled) return;

      toggle.addEventListener('click', function () {
        var row = toggle.closest('.ia-row');
        var panel = row ? row.querySelector('[data-ia-panel]') : null;
        if (!panel) return;

        var isOpen = toggle.getAttribute('aria-expanded') === 'true';

        if (isOpen) {
          toggle.setAttribute('aria-expanded', 'false');
          panel.style.maxHeight = '0px';
        } else {
          toggle.setAttribute('aria-expanded', 'true');
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    });
  });
})();